import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'bidi-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {

  @Input() text: string;
  @Input() progress: number;

  constructor() {

  }

  ngOnInit() {
  }

}
